import styles from './Scorecard.module.css';
import ScoreDetail from '../ScoreDetail';
import  {useState} from 'react';

function Scorecard({
    name,
    totalScore,
    overallRank,
    typeRank,
    type,
    puzzleResults,
    puzzles,
    clean,
    division,
    typeFilter
}){

    const [state, setState] = useState('closed');

    const handleClick = function(e){
        console.log(state);
        setState((state === 'open' ? 'closed' : 'open'));
    }

    return (
        <div className={styles.scorecard} onClick={handleClick}>
            <div className={styles.rank}>{typeFilter === 'All' ? overallRank : typeRank}</div>
            <div className={styles.detail}>
                <div className={styles.label}>{name} {
                    clean && <span>&#x2B50;</span> 
                }</div>
                <div>{type} {division && '| ' + division} </div>
                <div className={styles.totalScore}>Overall Score: {totalScore}</div>
            </div>
            <ScoreDetail scores={puzzleResults} puzzles={puzzles} state={state} />
        </div>
    )

}

export default Scorecard;